import { render, staticRenderFns } from "./HistoryListItems.vue?vue&type=template&id=128a4c2a"
import script from "./HistoryListItems.vue?vue&type=script&lang=js"
export * from "./HistoryListItems.vue?vue&type=script&lang=js"
import style0 from "./HistoryListItems.vue?vue&type=style&index=0&id=128a4c2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports